import React from 'react';
import { ParticipantRoles } from '../types';

const ParticipantFilters = ({ 
  selectedRole, 
  onRoleChange, 
  searchTerm, 
  onSearchChange,
  selectedSection,
  onSectionChange 
}) => {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-4">
            <label htmlFor="roleFilter" className="form-label fw-bold">Filter by Role</label>
            <select 
              id="roleFilter"
              className="form-select" 
              value={selectedRole} 
              onChange={(e) => onRoleChange(e.target.value)}
            >
              <option value="">All Roles</option>
              <option value={ParticipantRoles.HANDLER}>Handlers</option>
              <option value={ParticipantRoles.BREEDER}>Breeders</option>
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="sectionFilter" className="form-label fw-bold">Filter by Section</label>
            <select 
              id="sectionFilter"
              className="form-select" 
              value={selectedSection} 
              onChange={(e) => onSectionChange(e.target.value)}
            >
              <option value="">All Sections</option>
              <option value="NORTH">North</option>
              <option value="CENTRAL">Central</option>
              <option value="SOUTH">South</option>
            </select>
          </div>

          <div className="col-md-4">
            <label htmlFor="searchFilter" className="form-label fw-bold">Search</label>
            <input
              id="searchFilter"
              type="text"
              className="form-control"
              placeholder="Search by name, loft, email..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantFilters;
